import { createFileRoute } from '@tanstack/react-router';
import { useEffect, useState } from 'react';
import { useSession } from '../../auth/session';
import { ScheduleVisitModal } from '../../features/visits/ScheduleVisitModal';
import { useVisitActions } from '../../features/visits/VisitActions';
import { VisitsPage } from '../../features/visits/VisitsPage';
import { fromSearchParams, toSearchParams, visitSearchSchema } from '../../features/visits/search';
import { Button } from '../../ui';

export const Route = createFileRoute('/_authed/')({
  validateSearch: visitSearchSchema,
  component: VisitsRoute,
});

function VisitsRoute(): React.JSX.Element {
  const params = Route.useSearch();
  const navigate = Route.useNavigate();
  const session = useSession();
  const [scheduling, setScheduling] = useState(false);
  const actions = useVisitActions();
  const open = params.open;
  useEffect(() => {
    if (!open) return;
    actions.openTimelineById(open);
    void navigate({ search: (prev) => ({ ...prev, open: undefined }), replace: true });
    // eslint-disable-next-line react-hooks/exhaustive-deps -- run once per deep link
  }, [open]);
  return (
    <>
      <VisitsPage
        title="IT Field Support Visits"
        search={fromSearchParams(params)}
        onSearch={(next) => void navigate({ search: toSearchParams(next) })}
        actions={actions.renderActions}
        onOpen={actions.openTimeline}
        headerAction={
          session.can('visit.schedule') ? (
            <Button variant="primary" onClick={() => setScheduling(true)}>
              + Schedule Visit
            </Button>
          ) : null
        }
      />
      {actions.modals}
      <ScheduleVisitModal open={scheduling} onClose={() => setScheduling(false)} />
    </>
  );
}
